// ---------------- PIZZAS ----------------
export const pizzas = [
  { name: "Vegán", price: "Hamarosan", desc: "Paradicsomos alap, gomba, kukorica, paradicsom, uborka" },
  { name: "Basic", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, paradicsom" },
  { name: "Sonkás", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, sonka" },
  { name: "Sonkás - kukoricás", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, sonka, kukorica" },

  { name: "SonGoKu", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, sonka, gomba, kukorica" },
  { name: "Magyaros", price: "Hamarosan", desc: "Paradicsomos alap, trappista sajt, füstölt sajt, paprikás szalámi, lilahagyma" },
  { name: "Szolnoki", price: "Hamarosan", desc: "Fokhagymás-tejfölös alap, mozzarella, bacon, kukorica, lilahagyma" },
  { name: "Hawaii", price: "Hamarosan", desc: "Paradicsomos alap, trappista sajt, sonka, ananász" },

  { name: "Szalámis", price: "Hamarosan", desc: "Paradicsomos alap, trappista sajt, paprikás szalámi" },
  { name: "4 Sajtos", price: "Hamarosan", desc: "Paradicsomos alap, vörös cheddar sajt, mozzarella sajt, füstölt sajt, trappista sajt" },
  { name: "Olaszok rémálma", price: "Hamarosan", desc: "Paradicsomos alap, vörös cheddar sajt, sonka, tarja, bacon" },
  { name: "Húsimádó", price: "Hamarosan", desc: "Paradicsomos alap, trappista sajt, sonka, tarja, bacon, szalámi" },

  { name: "Házi sárkány", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, jalapeño, pepperoni (édes), paprikás szalámi" },
  { name: "Los Polos", price: "Hamarosan", desc: "Fokhagymás-tejfölös alap, vörös cheddar sajt, füstölt sajt, mozzarella, szalámi" },
  { name: "Gyrosos", price: "Hamarosan", desc: "Fokhagymás-tejfölös alap, trappista sajt, gyros hús, paradicsom, lilahagyma, uborka" },
  { name: "Betyár", price: "Hamarosan", desc: "Paradicsomos alap, trappista sajt, szalámi, tarja, tükörtojás, zöld paprika, lilahagyma" },

  { name: "Csemege", price: "Hamarosan", desc: "Fokhagymás-tejfölös alap, mozzarella, füstölt sajt, sonka, gyros hús, kukorica, lilahagyma" },
  { name: "Utolsó Kívánság", price: "Hamarosan", desc: "Paradicsomos alap, mozzarella, 5 kívánság" },

  { name: "Extra feltét", price: "Hamarosan", unit: "Ft/db" },
  { name: "Teljes kiőrlésű pizzatészta", price: "Hamarosan", note: "+500 Ft" },
];


// ---------------- GYROS ----------------
export const gyros = [
  {
    name: "Gyros tál",
    price: "Hamarosan",
    desc: "Csirke gyros hús, hasábburgonya, pita, friss saláta, hagyma, tzatziki és erős öntet (habanero paprikával)",
  },
  {
    name: "Sajtos gyros tál",
    price: "Hamarosan",
    desc: "Sajt, csirke gyros hús, hasábburgonya, pita, friss saláta, hagyma, tzatziki és erős öntet (habanero paprikával)",
  },
  {
    name: "Görög gyros tál",
    price: "Hamarosan",
    desc: "Csirke gyros hús, hasábburgonya, pita, görög saláta (uborka, paradicsom, olívabogyó, feta sajt), hagyma, tzatziki, erős öntet (habanero paprikával)",
  },
  {
    name: "Édesburgonyás gyros tál",
    price: "Hamarosan",
    desc: "Csirke gyros hús, édesburgonya, pita, friss saláta, hagyma, tzatziki és erős öntet (habanero paprikával)",
  },
  {
    name: "Húsos gyros tál",
    price: "Hamarosan",
    desc: "Dupla adag csirke gyros hús, hasábburgonya, pita, tzatziki és erős öntet (habanero paprikával)",
  },
];

export const gyrosExtras = [
  { name: "Édesburgonyával", price: "Hamarosan", note: "Hasáb helyett édesburgonyával" },
  { name: "Extra feltét", price: "Hamarosan", unit: "Ft/db", note: "Jalapeno, sajt, pita" },
  { name: "Extra öntet", price: "Hamarosan", unit: "Ft/db", note: "Tzatziki, csípős" },
];


// ---------------- DESSERTS ----------------
export const desserts = [
  { name: "Túrós", price: "Hamarosan" },
  { name: "Baracklekváros", price: "Hamarosan" },
  { name: "Nutellás", price: "Hamarosan" },
  { name: "Kakaós", price: "Hamarosan" },
  { name: "Fahéjas", price: "Hamarosan" },
  { name: "Vaníliakrémes", price: "Hamarosan" },
];


// ---------------- SIDES ----------------
export const sides = [
  {
    name: "Mexikói sültkrumpli tál",
    price: "Hamarosan",
    desc: "Hasábburgonya, cheddar szósz, jalapeño, erős öntet (habanero paprikával)",
  },
  { name: "Hasábburgonya", price: "Hamarosan" },
  { name: "Édesburgonya", price: "Hamarosan" },
];


// ---------------- DRINKS ----------------
export const drinks = [
  { name: "Coca-Cola, Coca-Cola Zero (0.33 L)", price: "Hamarosan" },
  { name: "Sprite, Coca-Cola, Coca-Cola Zero (0.5 L)", price: "Hamarosan" },
];
